module.exports = __webpack_public_path__ + "static/media/9.8d9574f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/9.png
// module id = 857
// module chunks = 0